import {
    getCoordinates,
    getDistanceFromInputs,
    handleDistanceError,
    initAutocompleteKota,
    tampilkanPetaSingleTrip 
} from '../../helper/setupAutocompleteCity.js';

function resetPenjadwalan() {
    // reset input hidden
    document.getElementById("kotaPenjemputanDriver").value = "";

    // reset output jarak
    document.getElementById("outputJarakDriver").textContent = "";

    // reset map (sembunyiin lagi)
    const mapDiv = document.getElementById("mapDriver");
    mapDiv.classList.add("hidden");
    if (mapDiv._leaflet_id) {
        mapDiv._leaflet_id = null;
        mapDiv.innerHTML = "";
    }
}

export function showModalDriver(modalId, cityId, driver_id, tanggalStr, firstData, selectedDriver) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  const inputs = document.querySelectorAll("input, textarea, select");
  const content = modal.querySelector("#modalContentDriver");
  const dateText = modal.querySelector("#modalDateDriver");
  const typeEl = modal.querySelector("#modalTypeDriver");
  const transmissionEl = modal.querySelector("#modalTransmissionDriver");
  const yearEl = modal.querySelector("#modalYearDriver");
  const imageEl = modal.querySelector("#modalImageDriver");
  const idUnit = modal.querySelector("#car_unit_id");
  const tujuanDriver = modal.querySelector("#kotaTujuanDriver");
  const chkDalamKotaDriver = document.getElementById("chkDalamKotaDriver");
  const lblDalamKotaDriver = document.getElementById("lblDalamKotaDriver");
  const kotaPenjemputanDriver = "Surabaya";
  initAutocompleteKota();

  let distanceKm = 0;

  // Ambil data driver berdasarkan ID
  if (driver_id) {
    fetch(`/driver/get-driver-order-by-user-id?driver_id=${driver_id}`)
    .then(res => res.json())
    .then(json => {
        const d = json?.data?.[0];
        if (!d) return;

        const imgEl = document.getElementById("modalImageDriver");
        imgEl.src = d.photo ? `/images/${d.photo}` : "/images/no-image.png";
        imgEl.alt = d.user_name || "Foto Driver";

        document.getElementById("modalNamaDriver").textContent = d.user_name || "-";
        document.getElementById("modalTeleponDriver").textContent = d.driver_phone || "-";
        document.getElementById("modalEmailDriver").textContent = d.user_email || "-";
        document.getElementById("modalAlamatDriver").textContent = d.driver_address || "-";
        document.getElementById("modalDeskripsiDriver").textContent = d.description || "-";        
    })
    .catch(err => console.error(err));
  }

  // Ambil data unit mobil
  fetch(`/driver/get-unit-by-city?city_id=${cityId}`)
    .then(res => {
      if (!res.ok) throw new Error("Gagal ambil data mobil");
      return res.json();
    })
    .then(resJson => {
      const data = Array.isArray(resJson) ? resJson : resJson.data || [];

      const select = document.getElementById("nama_unit");
      select.innerHTML = '<option value="">-- Pilih Unit --</option>';

      data.forEach(item => {
        const option = document.createElement("option");
        option.value = item.car_type_id;
        option.textContent = `${item.car_type_name} - ${item.plat_nomor}`;
        select.appendChild(option);
      });

      if (idUnit) idUnit.value = data?.[0]?.car_type_id || "-";
      if (typeEl) typeEl.textContent = data?.[0]?.car_type_name || "-";
      if (transmissionEl) transmissionEl.textContent = data?.[0]?.transmission || "-";
      if (yearEl) yearEl.textContent = data?.[0]?.year || "-";
      if (dateText) dateText.textContent = tanggalStr || "-";
    })
    .catch(err => {
      console.error("Error fetch unit:", err);
    });

function updateInputState() {
        if (chkDalamKotaDriver.checked) {
            tujuanDriver.disabled = true;
            tujuanDriver.placeholder = "";
            tujuanDriver.value = "";
            lblDalamKotaDriver.style.color = "blue";
        } else {
            tujuanDriver.disabled = false;
            tujuanDriver.placeholder = "Kota Tujuan";
            lblDalamKotaDriver.style.color = "gray";
        }
    }

    updateInputState();
    chkDalamKotaDriver.addEventListener("change", updateInputState);

    inputs.forEach((input) => {
        input.addEventListener("focus", () => {
            setTimeout(() => {
                input.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 300);
        });
    });

    const pairs = [
        {
            asal: 'Surabaya',
            tujuan: "tujuanDriver",
            output: "outputJarakDriver",
        },
    ];

    // Hitung jarak saat halaman load
    getDistanceFromInputs(pairs).then(([jarak]) => {
        
        if (jarak) {
            distanceKm = jarak;

            // 🚩 Tampilkan peta rute awal
            const asalEl = kotaPenjemputanDriver;
            const tujuanEl = document.getElementById("tujuanDriver");

            if (asalEl.dataset.lat && tujuanEl.dataset.lat) {
                tampilkanPetaSingleTrip({
                    latAsal: parseFloat(asalEl.dataset.lat),
                    lonAsal: parseFloat(asalEl.dataset.lon),
                    latTujuan: parseFloat(tujuanEl.dataset.lat),
                    lonTujuan: parseFloat(tujuanEl.dataset.lon),
                    mapId: "mapDriver",
                });
            }
        }
    });

    // Hitung jarak ulang saat user blur input kota
    ["tujuanDriver"].forEach((id) => {
        document.getElementById(id)?.addEventListener("blur", async () => {
            const asal = document.getElementById("kotaPenjemputanDriver");
            const tujuan = document.getElementById("tujuanDriver");

            if (asal?.value && tujuan?.value) {
                try {
                    // Ambil koordinat
                    await getCoordinates(asal);
                    await getCoordinates(tujuan);

                    const pairs = [
                        {
                            asal: "kotaPenjemputanDriver",
                            tujuan: "tujuanDriver",
                            output: "outputJarakDriver",
                        },
                    ];

                    const [jarak] = await getDistanceFromInputs(pairs);

                    if (jarak) {
                        distanceKm = jarak;

                        tampilkanPetaSingleTrip({
                            latAsal: parseFloat(asal.dataset.lat),
                            lonAsal: parseFloat(asal.dataset.lon),
                            latTujuan: parseFloat(tujuan.dataset.lat),
                            lonTujuan: parseFloat(tujuan.dataset.lon),
                            mapId: "mapDriver",
                        });
                    }
                } catch (err) {
                    handleDistanceError(err);
                }
            }
        });
    });

    // Kosongkan data saat fokus
    document.querySelectorAll("#kotaTujuanDriver").forEach((el) => {
        el.addEventListener("focus", () => {
            el.value = "";
            el.removeAttribute("data-lat");
            el.removeAttribute("data-lon");
            el.classList.remove("border-red-500");
        });
    });

  // Tampilkan modal dengan animasi
  document.body.classList.add("overflow-hidden");
  modal.classList.remove("hidden");

  setTimeout(() => {
    if (content) {
      content.classList.remove("scale-0", "opacity-0");
      content.classList.add("scale-100", "opacity-100");
    }
    [typeEl, transmissionEl, yearEl, dateText].forEach(el => {
      if (el) {
        el.classList.remove("opacity-0", "translate-y-2", "blur-sm");
        el.classList.add("transition-all", "duration-300");
      }
    });
  }, 10);
}

export function closeModalDriver(modalId) {
  const modal = document.getElementById(modalId);
  const content = modal?.querySelector("#modalContentDriver");
  const nameEl = modal?.querySelector("#modalNameDriver");
  const cityEl = modal?.querySelector("#modalCityDriver");
  const dateText = modal?.querySelector("#modalDateDriver");

  if (!modal || !content) return;

  content.classList.remove("scale-100", "opacity-100");
  content.classList.add("scale-0", "opacity-0");

  [nameEl, cityEl, dateText].forEach(el => {
    if (el) el.style.visibility = "hidden";
  });

  setTimeout(() => {
    modal.classList.add("hidden");

    // Reset animasi teks
    [nameEl, cityEl, dateText].forEach(el => {
      if (el) {
        el.textContent = "";
        el.classList.remove("opacity-100", "translate-y-0", "blur-0");
        el.classList.add("opacity-0", "translate-y-2", "blur-sm");
        el.style.visibility = "visible";
      }
    });

    // Reset form
    const form = document.getElementById("data_customer_form_driver");
    if (form) form.reset();

    // Reset gambar dan info driver
    const imgEl = document.getElementById("modalImageDriver");
    if (imgEl) {
      imgEl.src = "/images/no-image.png";
      imgEl.alt = "Foto Driver";
    }
    document.getElementById("modalNamaDriver").textContent = "-";
    document.getElementById("modalTeleponDriver").textContent = "-";
    document.getElementById("modalEmailDriver").textContent = "-";
    document.getElementById("modalAlamatDriver").textContent = "-";
    document.getElementById("modalDeskripsiDriver").textContent = "-";
    document.getElementById("outputJarakDriver").textContent = "-";

    content.classList.remove("scale-0", "opacity-0");
    content.classList.add("scale-100", "opacity-100");

    document.body.classList.remove("overflow-hidden");
  }, 500);
}

function formatTanggalIndonesia(tanggalStr) {
  const options = { day: "2-digit", month: "long", year: "numeric" };
  const dateObj = new Date(tanggalStr);
  return dateObj.toLocaleDateString("id-ID", options);
}

function formatJam(tanggalStr) {
  const dateObj = new Date(tanggalStr);
  return dateObj.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
}

export function showModalImageDriver(
  image,
  name,
  driverAddress,
  driverPhone,
  driverJoinDate,
  driverDescription,
  driverActive
) {
  const modalImageViewer = document.getElementById("modalDetailsDriver");
  const modalContentDetailsDriver = modalImageViewer?.querySelector("#modalContentDetailsDriver");
  const modalImg = document.getElementById("driverModalImage");
  const nameEl = document.getElementById("driverModalName");
  const addressEl = document.getElementById("driverModalAddress");
  const phoneEl = document.getElementById("driverModalPhone");
  const joinDateEl = document.getElementById("driverModalJoinDate");
  const descriptionEl = document.getElementById("driverModalDescription");
  const activeEl = document.getElementById("driverActive");

  if (!modalImageViewer || !modalImg) {
    console.warn("Elemen modal gambar tidak ditemukan.");
    return;
  }

  modalImg.src = image;
  nameEl.textContent = name;
  addressEl.textContent = driverAddress;
  phoneEl.textContent = driverPhone;
  joinDateEl.textContent = driverJoinDate;
  descriptionEl.textContent = driverDescription;

  modalImageViewer.classList.remove("hidden");
  document.body.classList.add("overflow-hidden");

  const forms = document.querySelectorAll("form, input, button, select, textarea");
  forms.forEach(el => el.setAttribute("disabled", "true"));

  setTimeout(() => {
    if (modalContentDetailsDriver) {
      modalContentDetailsDriver.classList.remove("scale-95", "opacity-0", "translate-y-10");
      modalContentDetailsDriver.classList.add("scale-100", "opacity-100", "translate-y-0");
    }
    if (modalImg) {
      modalImg.classList.remove("opacity-0", "translate-y-2", "blur-sm");
      modalImg.classList.add("opacity-100", "translate-y-0", "transition-all", "duration-300", "ease-out");
    }
  }, 10);
}

export function closeModalImageDriver(modalId) {
  const modalDriverImage = document.getElementById(modalId);
  const contentDriverImage = modalDriverImage?.querySelector("#modalContentDetailsDriver");
  const modalImg = document.getElementById("driverModalImage");
  const nameEl = document.getElementById("driverModalName");
  const addressEl = document.getElementById("driverModalAddress");
  const phoneEl = document.getElementById("driverModalPhone");
  const joinDateEl = document.getElementById("driverModalJoinDate");
  const descriptionEl = document.getElementById("driverModalDescription");
  const activeEl = document.getElementById("driverActive");

  if (!modalDriverImage || !contentDriverImage) {
    console.warn("Modal atau kontennya tidak ditemukan.");
    return;
  }

  contentDriverImage.classList.remove("scale-100", "opacity-100", "translate-y-0");
  contentDriverImage.classList.add("scale-95", "opacity-0", "translate-y-10");

  if (modalImg) {
    modalImg.classList.add("opacity-0", "translate-y-2", "blur-sm");
  }

  [nameEl, addressEl, phoneEl, joinDateEl, descriptionEl, activeEl].forEach(el => {
    if (el) el.style.visibility = "hidden";
  });

  setTimeout(() => {
    modalDriverImage.classList.add("hidden");

    [nameEl, addressEl, phoneEl, joinDateEl, descriptionEl, activeEl].forEach(el => {
      if (el) {
        el.textContent = "";
        el.classList.remove("opacity-100", "translate-y-0", "blur-0");
        el.classList.add("opacity-0", "translate-y-2", "blur-sm");
        el.style.visibility = "visible";
      }
    });

    contentDriverImage.classList.remove("scale-95", "opacity-0", "translate-y-10");
    contentDriverImage.classList.add("scale-100", "opacity-100", "translate-y-0");

    const forms = document.querySelectorAll("form, input, button, select, textarea");
    forms.forEach(el => el.removeAttribute("disabled"));
    document.body.classList.remove("overflow-hidden");
  }, 500);
}
